import React from 'react'
import { Navigate } from 'react-router-dom'
import { useSimpleAuth  } from '../../features/auth/SimpleAuthContext'

const ProtectedRoute = ({ children }) => {
  const { currentUser, isLoading } = useSimpleAuth()

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2" style={{borderColor: '#3BC6C6'}}></div>
      </div>
    )
  }

  // Redirect if not authenticated
  if (!currentUser) {
    return <Navigate to="/auth/login" replace />
  }

  return children
}

export default ProtectedRoute
